import { render, staticRenderFns } from "./Footers.vue?vue&type=template&id=7238d4aa&scoped=true"
import script from "./Footers.vue?vue&type=script&lang=js"
export * from "./Footers.vue?vue&type=script&lang=js"
import style0 from "./Footers.vue?vue&type=style&index=0&id=7238d4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238d4aa",
  null
  
)

export default component.exports